


































import Vue from "vue";
import { PropType } from "vue";
import { Data, Methods, Computed, Props, SettingLabel } from "./types";
import LayoutColumnSingle from "@/components/Atoms/Layout/ColumnSingle/index.vue";
import Suffix from "@/components/Atoms/Typography/Suffix/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Button from "@/components/Atoms/Button/index.vue";
import ButtonConfig from "@/components/Molecules/ButtonConfig/index.vue";
import LoadingView from "@/components/Molecules/LoadingView/index.vue";
import SettingTable from "./Molecules/SettingTable/index.vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "SettingsNotification",
  components: {
    LayoutColumnSingle,
    Suffix,
    Heading,
    Button,
    ButtonConfig,
    LoadingView,
    SettingTable
  },
  props: {
    notificationSetting: {
      type: Object as PropType<Props["notificationSetting"]>,
      default: undefined
    },
    isLoading: {
      type: Boolean as PropType<Props["isLoading"]>,
      required: true
    },
    isProcessing: {
      type: Boolean as PropType<Props["isProcessing"]>,
      required: true
    }
  },
  data() {
    return {
      nextNotificationSetting: null,
      buttonText: "変更を保存"
    };
  },
  computed: {
    isDisabledButton() {
      return (
        !this.notificationSetting ||
        !this.nextNotificationSetting ||
        this.isSame
      );
    },
    isSame() {
      if (!this.nextNotificationSetting) return false;
      return Object.entries(this.nextNotificationSetting).every(
        ([key, val]) => this.notificationSetting[key as SettingLabel] === val
      );
    }
  },
  methods: {
    changeNotificationSetting(newNotificationSetting) {
      this.nextNotificationSetting = newNotificationSetting;
      this.buttonText = "変更を保存";
    },
    updateNotificationSetting() {
      this.$emit("updateNotificationSetting", this.nextNotificationSetting);
      this.nextNotificationSetting = null;
      this.buttonText = "変更を保存しました";
    }
  }
});
